/* global angular */
angular.module('ua5App.index.list')
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('index.list.artists', {
                url: '/artists',
                templateUrl: 'states/index.list/index.list.artists/index.list.artists.html',
                controller: 'ListArtistsCtrl',
                controllerAs: 'ctrl'
            })
        ;
    }])
    .controller('ListArtistsCtrl', [
    'posts',
    'MetaFactory',
    '$filter',
    function(posts, MetaFactory, $filter) {
        var artists = [];
        var makeSort;
        var self = this;
        self.artists = [];
        angular.forEach(posts, function(post) {
            var slug = post.slug;
            artists.push({
                name: post.title,
                slug: slug
            });
        });

        makeSort = function(name) {
            var sortBy = name.split(' ').slice(-1)[0];
            switch (name) {
                case 'Gerard &#038; Kelly':
                    sortBy = 'Gerard & Kelly';
                    break;
                case 'Lee Bul':
                    sortBy = 'Lee Bul';
                    break;
                case 'Natascha Sadr Haghighian':
                    sortBy = 'Sadr Haghighian';
                    break;
                case 'Mariana Castillo Deball':
                    sortBy = 'Castillo Deball';
                    break;
            }
            return sortBy;
        };

        artists = $filter('orderBy')(artists, function(artist) {
            artist.lastName = makeSort(artist.name);
            return artist.lastName;
        });
        self.artists = artists;
        // Set meta information
        MetaFactory.set({
            title: 'Artists List | Storylines: Contemporary Art at the Guggenheim',
            description: 'Every work of art has a story. Explore 100+ contemporary works from the @Solomon R. Guggenheim Museum collection in Storylines',
            ogTitle: 'Artists List | Storylines: Contemporary Art at the Guggenheim',
            ogDescription: 'Every work of art has a story. Explore 100+ contemporary works from the @Solomon R. Guggenheim Museum collection in Storylines',
            ogImage: ''
        });
    }])
;
